import React from 'react';

import { StyledButton, StyledFilledHoverButton } from 'styles/common';

import theme from 'constants/theme';

export const ButtonFilled = ({ width = null, ...props }) => {
  if (width) {
    props = { ...props, style: { width } };
  }
  return (
    <StyledButton
      customColor={theme.palette.primary.main}
      fontColor={theme.palette.text.white}
      padding="8px 24px"
      style={{ height: '40px' }}
      {...props}
    />
  );
};

export const ButtonOutlined = ({ width = null, ...props }) => {
  if (width) {
    props = { ...props, style: { width } };
  }
  return <StyledButton variant="outlined" fontColor={theme.palette.text.label} padding="8px 24px" {...props} />;
};

export const ButtonOutlinedHoverFilled = ({
  width = null,
  selected = false,
  hoverBorderColor,
  borderColor,
  ...props
}) => {
  if (width) {
    props = { ...props, style: { width } };
  }
  return (
    <StyledFilledHoverButton
      borderColor={borderColor}
      hoverBorderColor={hoverBorderColor}
      variant="outlined"
      padding="8px 28px"
      selected={selected}
      {...props}
    />
  );
};

export const TextButtonHoverFilled = ({ width = null, selected = false, hoverBorderColor, borderColor, ...props }) => {
  if (width) {
    props = { ...props, style: { width } };
  }
  return (
    <StyledFilledHoverButton
      borderColor={borderColor}
      hoverBorderColor={hoverBorderColor}
      variant="text"
      padding="8px 28px"
      selected={selected}
      {...props}
    />
  );
};
